import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider } from 'styled-components';
import GlobalStyle from './cssReset/css_reset';
import { theme } from './theme';
import { RecoilRoot } from 'recoil';

// CRA 개발 오버레이: ResizeObserver loop 경고는 브라우저 정상 동작(무해)이라 무시
if (process.env.NODE_ENV === 'development') {
  const isResizeObserverLoop = (value: unknown) => {
    const msg =
      typeof value === 'string'
        ? value
        : value instanceof Error
          ? value.message
          : String(value ?? '');
    return (
      msg.includes('ResizeObserver loop completed with undelivered notifications') ||
      msg.includes('ResizeObserver loop limit exceeded')
    );
  };

  window.addEventListener(
    'error',
    (event) => {
      if (isResizeObserverLoop(event.message) || isResizeObserverLoop(event.error)) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true,
  );

  const originalOnError = window.onerror;
  window.onerror = (message, source, lineno, colno, error) => {
    if (isResizeObserverLoop(message) || isResizeObserverLoop(error)) {
      return true;
    }
    if (typeof originalOnError === 'function') {
      return originalOnError(message, source, lineno, colno, error);
    }
    return false;
  };

  const originalConsoleError = console.error;
  console.error = (...args: unknown[]) => {
    if (args.some((arg) => isResizeObserverLoop(arg))) {
      return;
    }
    originalConsoleError.apply(console, args as Parameters<typeof console.error>);
  };
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

const queryClient = new QueryClient();
root.render(
  <React.StrictMode>
    <RecoilRoot>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <App />
        </ThemeProvider>
      </QueryClientProvider>
    </RecoilRoot>
  </React.StrictMode>,
);
